export function initPhoneVerification() {
  const $container = $('[data-controller="phone-verification"]');
  if ($container.length === 0) return;

  const $phoneInput = $container.find('[data-phone-verification-target="phoneInput"]');
  const $verifyBtn = $container.find('[data-phone-verification-target="verifyBtn"]');
  const $removeBtn = $container.find('[data-phone-verification-target="removeBtn"]');
  const $codeDisplay = $container.find('[data-phone-verification-target="codeDisplay"]');
  const $validationCode = $container.find('[data-phone-verification-target="validationCode"]');
  const $errorDisplay = $container.find('[data-phone-verification-target="errorDisplay"]');
  const $successDisplay = $container.find('[data-phone-verification-target="successDisplay"]');
  const $pendingAlert = $container.find('[data-phone-verification-target="pendingAlert"]');

  let pollingInterval: ReturnType<typeof setInterval> | null = null;
  let currentCallSid: string | null = null;

  // If there's a stale pending verification on page load, clear it
  // (we don't have call_sid to check status, so user needs to retry)
  if ($pendingAlert.length > 0) {
    // Clear stale verification after a few seconds
    setTimeout(function() {
      $.ajax({
        url: '/phone_verifications/check',
        method: 'GET',
        data: { clear_stale: 'true' },
        success: function(response) {
          if (!response.verified && !response.verification_pending) {
            // Pending state was cleared, reload to show verify button
            window.location.reload();
          }
        }
      });
    }, 3000);
  }

  $verifyBtn.off('click').on('click', function() {
    const phoneNumber = ($phoneInput.val() as string || '').trim();

    if (!phoneNumber) {
      showError('Please enter a phone number');
      return;
    }

    $verifyBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm"></span> Calling...');
    hideError();

    $.ajax({
      url: '/phone_verifications',
      method: 'POST',
      data: { phone_number: phoneNumber },
      success: function(response) {
        if (response.success) {
          if (response.already_verified) {
            // Number was already verified in Twilio - show success and reload
            $successDisplay.removeClass('d-none');
            setTimeout(function() {
              window.location.reload();
            }, 1500);
          } else {
            currentCallSid = response.call_sid;
            $validationCode.text(response.validation_code);
            $codeDisplay.removeClass('d-none');
            $verifyBtn.hide();
            startPolling();
          }
        } else {
          showError(response.error || 'Failed to start verification');
          resetVerifyButton();
        }
      },
      error: function(xhr) {
        const response = xhr.responseJSON;
        showError(response?.error || 'Failed to start verification');
        resetVerifyButton();
      }
    });
  });

  $removeBtn.off('click').on('click', function() {
    if (!confirm('Are you sure you want to remove your verified phone number?')) {
      return;
    }

    $removeBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm"></span>');

    $.ajax({
      url: '/phone_verifications',
      method: 'DELETE',
      success: function() {
        window.location.reload();
      },
      error: function(xhr) {
        const response = xhr.responseJSON;
        showError(response?.error || 'Failed to remove phone verification');
        $removeBtn.prop('disabled', false).text('Remove');
      }
    });
  });

  function startPolling() {
    if (pollingInterval) return;

    let pollCount = 0;
    const maxPolls = 20; // 20 * 3 seconds = 60 seconds max

    pollingInterval = setInterval(function() {
      pollCount++;

      // Timeout after 60 seconds
      if (pollCount > maxPolls) {
        stopPolling();
        $codeDisplay.addClass('d-none');
        $pendingAlert.addClass('d-none');
        showError('Verification timed out. The call may have failed. Please try again.');
        resetVerifyButton();
        // Clear pending state in DB
        $.ajax({ url: '/phone_verifications/check', method: 'GET', data: { clear_stale: 'true' } });
        return;
      }

      const params: { call_sid?: string } = {};
      if (currentCallSid) {
        params.call_sid = currentCallSid;
      }

      $.ajax({
        url: '/phone_verifications/check',
        method: 'GET',
        data: params,
        success: function(response) {
          if (response.verified) {
            stopPolling();
            $codeDisplay.addClass('d-none');
            $pendingAlert.addClass('d-none');
            $successDisplay.removeClass('d-none');

            // Reload after a short delay
            setTimeout(function() {
              window.location.reload();
            }, 2000);
          } else if (response.error) {
            // Call failed with error
            stopPolling();
            $codeDisplay.addClass('d-none');
            $pendingAlert.addClass('d-none');
            showError(response.error);
            resetVerifyButton();
          } else if (!response.verification_pending) {
            // Verification failed or was cancelled
            stopPolling();
            $codeDisplay.addClass('d-none');
            $pendingAlert.addClass('d-none');
            showError('Verification failed or timed out. Please try again.');
            resetVerifyButton();
          } else if (response.call_status) {
            // Update status display
            const statusText = response.call_status === 'queued' ? 'Call queued...' :
                              response.call_status === 'ringing' ? 'Phone ringing...' :
                              response.call_status === 'in-progress' ? 'Call in progress - enter the code!' :
                              'Waiting for verification...';
            $codeDisplay.find('.verification-status-text').text(statusText);
          }
        }
      });
    }, 3000); // Poll every 3 seconds
  }

  function stopPolling() {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  }

  function showError(message: string) {
    $errorDisplay.text(message).removeClass('d-none');
  }

  function hideError() {
    $errorDisplay.addClass('d-none');
  }

  function resetVerifyButton() {
    $verifyBtn.prop('disabled', false).html('Verify').show();
  }
}
